import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
import DataCacheService from '@/shared/services/DataCacheService';
export const useUpdateHrmSettings = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(({ companyId, model }) => api.base
        .put('/api/settings/hrm', model, { params: { id: companyId } })
        .then(res => res.data), {
        onSuccess: (_result, variables) => {
            queryClient.setQueryData([SettingsQueryKey.HrmSettings, variables.companyId], variables.model);
            const { registrationMinimumDate, absenceMinimumDate, allowRegistrationLocking, } = variables.model;
            const propagated = {
                registrationMinimumDate,
                absenceMinimumDate,
                allowRegistrationLocking,
            };
            DataCacheService.updateAllCompanies(propagated);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateHrmSettings: mutateAsync, isLoading };
};
